import FeatPane from './FeatPane';

export default FeatPane;
export { FeatPane };
